import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, CardBody, CardHeader, Col, Form, FormFeedback, Input, Label, ListGroup, ListGroupItem, Row, Spinner, Table } from 'reactstrap';
import { GlobalStore } from '../../../StateStores';
import { fetchVehicleStatus } from '../../../Actions/InspectionActs';
import { toast } from 'react-toastify';

const VehicleStatus = ({canvas,setCanvas})=>{
    const navigate = useNavigate();
    const [formValid, setFormValid] = useState(false);
    const [form,setForm] = useState({plate_number:'',});
    const [formErrors,setFormErrors] = useState({plate_number:'Plate number is required',});
    const [vehicleData,setVehicleData] = useState({});
    const [vehicleInsuranceData,setVehicleInsuranceData] = useState({});

    const {InspectionDispatch,InspectionState:{
        getVehicleStatus:{error,loading,data},
    }} = useContext(GlobalStore);

    useEffect(() => {
        const isValid = Object.values(formErrors).every(item => !item);
        setFormValid(isValid);
    }, [formErrors]);

    const onChange = ({name,value}) => {
        if(name === 'plate_number') value = value.toUpperCase();
        setForm((prev) => ({ ...prev, [name]: value }));
        if (value) {
            setFormErrors(prev => ({ ...prev, [name]: '' }));
        } else {
            setFormErrors(prev => ({ ...prev, [name]: 'This field is required' }));
        }

    }

    const onSubmit = async (e) => {
        e.preventDefault();

        if(formValid){
            try {
                const response = await fetchVehicleStatus(form)(InspectionDispatch);
                
                if(response.status){
                    const {vehicle,insurance} = response.data;
                    setVehicleData(vehicle)
                    setVehicleInsuranceData(insurance?.CoverNoteDtl)
                }else{
                    toast.error(response.message)
                }
            } catch (error) {
                toast.error(error.message)
            }
        }
    }

    /**
     * Clear the searched data
     */
    const clearFetchedData = ()=>{
        setVehicleData({})
        setVehicleInsuranceData({})
        setForm({plate_number:''})
        setFormErrors({plate_number:'Plate number is required'})
    }

    return(
        <React.Fragment>
            <div className={`d-flex flex-column justify-content-center align-items-center ${Object.keys(vehicleData).length > 0? '':'h-100'}`}>
                {Object.keys(vehicleData).length === 0 && (
                    <div className="w-100 px-3a">
                        <Form onSubmit={onSubmit}>
                            <Row>
                                <Col>
                                    <Label>Enter plate number</Label>
                                    <Input 
                                        type='text' 
                                        placeholder='Enter vehicle No. e.g T133ABC'
                                        value={form?.plate_number}
                                        onChange={(e) => onChange({name:'plate_number',value:e.target.value})}
                                        valid={formErrors.plate_number === ''}
                                        invalid={formErrors.plate_number !== ''}
                                    />
                                    {formErrors.plate_number && <FormFeedback>{formErrors.plate_number}</FormFeedback>}
                                </Col>
                            </Row>
                            <div className='mt-2 d-flex justify-content-end'>
                                <Button disabled={!formValid} size='sm'>
                                    {loading && <Spinner size="sm"/>}
                                    <span className='ms-1'>Fetch data</span>
                                </Button>
                            </div>
                        </Form>
                    </div>
                )}

                {Object.keys(vehicleData).length > 0 && (
                    <React.Fragment>
                        <div className='w-100'>
                            <Card className='shadow-sm'>
                                <CardHeader>Vehicle Details</CardHeader>
                                <CardBody>
                                    <Table>
                                        <tr>
                                            <th>Owner:</th>
                                            <td className='text-end text-muted'>{vehicleData?.owner}</td>
                                        </tr>
                                        <tr>
                                            <th>RegNo:</th>
                                            <td className='text-end text-muted'>{vehicleData?.regno}</td>
                                        </tr>
                                        <tr>
                                            <th>Tin:</th>
                                            <td className='text-end text-muted'>{vehicleData?.tin}</td>
                                        </tr>
                                        <tr>
                                            <th>Address:</th>
                                            <td className='text-end text-muted'>{vehicleData?.address}</td>
                                        </tr>
                                        <tr>
                                            <th>Vehicle:</th>
                                            <td className='text-end text-muted'>{vehicleData?.vehicle}</td>
                                        </tr>
                                        <tr>
                                            <th>EngineNo:</th>
                                            <td className='text-end text-muted'>{vehicleData?.engineno}</td>
                                        </tr>
                                        <tr>
                                            <th>ChassisNo:</th>
                                            <td className='text-end text-muted'>{vehicleData?.chassisno}</td>
                                        </tr>
                                        <tr>
                                            <th>Desc:</th>
                                            <td className='text-end text-muted'>{vehicleData?.titledesc}</td>
                                        </tr>
                                        <tr>
                                            <th>Mobile:</th>
                                            <td className='text-end text-muted'>{vehicleData?.mobile}</td>
                                        </tr>
                                        <tr>
                                            <th>Driver:</th>
                                            <td className='text-end text-muted'>{vehicleData?.tdriver}</td>
                                        </tr>
                                    </Table>
                                </CardBody>
                            </Card>


                            <Card className='shadow-sm'>
                                <CardHeader>Vehicle Insurance Details</CardHeader>
                                <CardBody>
                                    <ListGroup>
                                        <ListGroupItem>
                                            <div><strong>Cover Note Type Desc:</strong></div>
                                            <small>{vehicleInsuranceData?.CoverNoteTypeDesc}</small>
                                        </ListGroupItem>
                                        <ListGroupItem>
                                            <div><strong>Cover Note Number:</strong></div>
                                            <small>{vehicleInsuranceData?.CoverNoteNumber}</small>
                                        </ListGroupItem>
                                        <ListGroupItem>
                                            <div><strong>Cover Note Reference Number:</strong></div>
                                            <small>{vehicleInsuranceData?.CoverNoteReferenceNumber}</small>
                                        </ListGroupItem>
                                        <ListGroupItem>
                                            <div><strong>Insurer Company Code:</strong></div>
                                            <small>{vehicleInsuranceData?.InsurerCompanyCode}</small>
                                        </ListGroupItem>
                                        <ListGroupItem>
                                            <div><strong>Insurer Company Name:</strong></div>
                                            <small>{vehicleInsuranceData?.InsurerCompanyName}</small>
                                        </ListGroupItem>
                                        <ListGroupItem>
                                            <div><strong>Cover Note Issue Date:</strong></div>
                                            <small>{vehicleInsuranceData?.CoverNoteIssueDate}</small>
                                        </ListGroupItem>
                                        <ListGroupItem>
                                            <div><strong>Cover Note Start Date:</strong></div>
                                            <small>{vehicleInsuranceData?.CoverNoteStartDate}</small>
                                        </ListGroupItem>
                                        <ListGroupItem>
                                            <div><strong>Cover Note End Date:</strong></div>
                                            <small>{vehicleInsuranceData?.CoverNoteEndDate}</small>
                                        </ListGroupItem>
                                        <ListGroupItem>
                                            <div><strong>Cover Note Desc:</strong></div>
                                            <small>{vehicleInsuranceData?.CoverNoteDesc}</small>
                                        </ListGroupItem>
                                        <ListGroupItem>
                                            <div><strong>Operative Clause:</strong></div>
                                            <small>{vehicleInsuranceData?.OperativeClause}</small>
                                        </ListGroupItem>
                                    </ListGroup>
                                </CardBody>
                            </Card>
                        </div>
                        <div className='d-flex justify-content-end'>
                            <Button size='sm' onClick={clearFetchedData}>
                                <span className='ms-1'>Reset</span>
                            </Button>
                        </div>
                    </React.Fragment>
                )}

                
            </div>
        </React.Fragment>
    )
}

export default VehicleStatus;